import { Controller, FieldValues, UseControllerProps } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ColorInput } from "@/sx-layout/components/ColorInput";
import { PresetColorPicker } from "@/sx-layout/components/PresetColorPicker";

type Props<T extends FieldValues> = UseControllerProps<T>;

export const ColorPickerFormController = <T extends FieldValues>({ name, control }: Props<T>) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className="flex-col">
          <ColorInput value={value} onChange={onChange} />
          <br />
          <p>{t("color_picker_description")}</p>
          <PresetColorPicker onChange={onChange} />
        </div>
      )}
    />
  );
};
